module.exports = __webpack_public_path__ + "img/arrow_back_ios.fed9888e.svg";